"use client";
import React from "react";
import { useContext } from "react";
import { RecentLeaderContext } from "@/context/RecentLeaderBoardContext";
import OddRateStats from "@/components/OddRateStats";

const OddStatistic = ({ oddStats, match }) => {
  const { home , away } = useContext(RecentLeaderContext);
  return (
    <>
      <OddRateStats home={home} away={away} oddStats={oddStats} match={match} />
    </>
  );
};

export default React.memo(OddStatistic);
